import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const k = {
    dialogHeader: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.reject-dialog.reject-dialog-i18n.dialogHeader",
    buttonSubmitText: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.reject-dialog.reject-dialog-i18n.buttonSubmitText",
    reason: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.reject-dialog.reject-dialog-i18n.reason"
};
export const translations = {
    da: {
        dialogHeader: "Afvis faktura",
        buttonSubmitText: "OK",
        reason: "Kommentar"
    },
    en: {
        dialogHeader: "Reject invoice",
        buttonSubmitText: "OK",
        reason: "Comment"
    }
};
export const useT = () => {
    const { t, i18n } = useTranslation();
    const localT = useMemo(() => ({
        dialogHeader: t(k.dialogHeader),
        buttonSubmitText: t(k.buttonSubmitText),
        reason: t(k.reason)
    }), [i18n.language]);
    return useMemo(() => ({ t: localT, i18n }), [localT, i18n]);
};
